export default __webpack_public_path__ + "static/media/avatar_2.dc502e28.svg";